/* eslint-disable no-unused-vars */
import React from 'react';

export function TextView(props) {
  const { em, data } = props;
  // const { parentSize } = em;
  const parentSize = em.parentSize || (props.parent && props.parent.size) || 'half';
  const floating = em.floating;
  const groupClass = (floating ? '' : 'row') + ' ' + (em.class ? em.class : '');
  const labelClass = floating ? 'd-block' : `col-sm-${parentSize === 'full' ? '2' : '5'} col-form-label`;

  let inputClass = (floating ? 'd-block' : `col-sm-${parentSize === 'full' ? '10' : '7'}`) + ' col-form-label';
  if (em.align && em.align !== '') inputClass += ` text-${em.align}`;

  let _formattedText = (props.data && em.field && props.data[em.field]) || '';
  if (em.format && em.format.type) {
    switch (em.format.type) {
      case 'number':
        _formattedText = new Intl.NumberFormat('en-US', em.format.options || {}).format(+_formattedText);
        break;

      case 'date': {
        const options = { day: 'numeric', month: 'short', year: 'numeric' };
        const dateFmt = new Intl.DateTimeFormat(props.locale || 'en-UK', em.format.options || options);
        _formattedText = _formattedText !== '' ? dateFmt.format(new Date(_formattedText)) : '';
        break;
      }

      default:
        break;
    }
  }

  if (em.append) {
    if (props.data && props.data[em.append]) {
      _formattedText += ` ${props.data[em.append]}`;
    } else {
      _formattedText += ` ${em.append}`;
    }
  }

  if (floating) {
    return (
      <div className={`form-group ${groupClass}`}>
        <small className={`${labelClass}`}>{em.label}</small>
        <label className={`${inputClass}`}>
          {_formattedText}
          <br />
        </label>
      </div>
    );
  } else {
    return (
      <div className={`form-group ${groupClass}`}>
        <label className={`${labelClass}`}>{em.label}</label>
        <label className={`${inputClass}`}>{_formattedText}</label>
      </div>
    );
  }
}

TextView.defaultProps = {
  em: {}, // parentSize: 'half'
};
